var _path, _path2, _rect, _path3, _rect2, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundersTripleDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#D1B277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2124)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#C7A572"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2124)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2124)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 26,
    width: 159,
    height: 158
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 26,
    width: 70,
    height: 153,
    transform: "rotate(45 114 26)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "black",
    fillOpacity: 0.3
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 121.061L21 105.03H25.3514L32.5 114.484V121.061Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 89L21 105.03H25.3514L32.5 95.5765V89Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 121.061L44 105.03H39.6486L32.5 114.484V121.061Z",
    fill: "#9F9F9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 89L44 105.03H39.6486L32.5 95.5765V89Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3574 105.03L32.5061 95.576L39.6547 105.03L32.5061 114.484L25.3574 105.03Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 121.061L76 105.03H80.3514L87.5 114.484V121.061Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 89L76 105.03H80.3514L87.5 95.5765V89Z",
    fill: "#F8F8F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 121.061L99 105.03H94.6486L87.5 114.484V121.061Z",
    fill: "#9F9F9F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 89L99 105.03H94.6486L87.5 95.5765V89Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3574 105.03L87.5061 95.576L94.6547 105.03L87.5061 114.484L80.3574 105.03Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0437 48.899C86.4191 47.3784 88.5809 47.3784 88.9563 48.899L89.7577 52.1455C89.8912 52.6864 90.3136 53.1087 90.8545 53.2423L94.1009 54.0437C95.6216 54.4191 95.6216 56.5809 94.1009 56.9563L90.8545 57.7577C90.3136 57.8912 89.8912 58.3136 89.7577 58.8545L88.9563 62.1009C88.5809 63.6216 86.4191 63.6216 86.0437 62.1009L85.2423 58.8545C85.1087 58.3136 84.6864 57.8912 84.1455 57.7577L80.899 56.9563C79.3784 56.5809 79.3784 54.4191 80.899 54.0437L84.1455 53.2423C84.6864 53.1087 85.1087 52.6864 85.2423 52.1455L86.0437 48.899Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0437 48.899C31.4191 47.3784 33.5809 47.3784 33.9563 48.899L34.7577 52.1455C34.8912 52.6864 35.3136 53.1087 35.8545 53.2423L39.1009 54.0437C40.6216 54.4191 40.6216 56.5809 39.1009 56.9563L35.8545 57.7577C35.3136 57.8912 34.8912 58.3136 34.7577 58.8545L33.9563 62.1009C33.5809 63.6216 31.4191 63.6216 31.0437 62.1009L30.2423 58.8545C30.1087 58.3136 29.6864 57.8912 29.1455 57.7577L25.899 56.9563C24.3784 56.5809 24.3784 54.4191 25.899 54.0437L29.1455 53.2423C29.6864 53.1087 30.1087 52.6864 30.2423 52.1455L31.0437 48.899Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5437 119.539C58.9191 118.019 61.0809 118.019 61.4563 119.539L62.2577 122.786C62.3912 123.327 62.8136 123.749 63.3545 123.882L66.6009 124.684C68.1216 125.059 68.1216 127.221 66.6009 127.596L63.3545 128.398C62.8136 128.531 62.3912 128.954 62.2577 129.495L61.4563 132.741C61.0809 134.262 58.9191 134.262 58.5437 132.741L57.7423 129.495C57.6087 128.954 57.1864 128.531 56.6455 128.398L53.399 127.596C51.8784 127.221 51.8784 125.059 53.399 124.684L56.6455 123.882C57.1864 123.749 57.6087 123.327 57.7423 122.786L58.5437 119.539Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60 112.643L35 77.8214H44.4595L60 98.3571V112.643Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43L35 77.8214H44.4595L60 57.2857V43Z",
    fill: "#F8F8F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60 112.643L85 77.8214H75.5405L60 98.3571V112.643Z",
    fill: "#9F9F9F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43L85 77.8214H75.5405L60 57.2857V43Z",
    fill: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4727 77.8202L60.0132 57.2845L75.5537 77.8202L60.0132 98.3559L44.4727 77.8202Z",
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2124",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#CFB58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED4A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2124",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBAB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 122,
    fill: "white",
    transform: "translate(9 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundersTripleDiamond);
export default __webpack_public_path__ + "static/media/foundersTripleDiamond.62afb63f3228628f659d5bfd13e4f760.svg";
export { ForwardRef as ReactComponent };